import parsePlanPeriod from 'utils/pivot/plan/period/parsePlanPeriod'
import generatePlanFilter from 'utils/pivot/plan/generatePlanFilter'
import findAlternativePlan from './findAlternativeFilter'
import store from 'utils/store/withMiddleware'

interface PlanConfigurationFilter {
  planFilter: PlanFilter
  hasForceFilterChange: boolean
  alternativePlanId: number | undefined
}
interface PlanConfigurationFilterOptions {
  planTypeKey: string
  filters: { filterName: string; filterValue: string }[]
  filtersByProductType: { [key: string]: PlanFilter }
}

export function fitPlanConfigurationForFilter({
  planTypeKey,
  filters,
  filtersByProductType
}: PlanConfigurationFilterOptions): PlanConfigurationFilter {
  const { plansSTM, plans } = store.getState()

  const plansByType = plansSTM.filter(planId => plans[planId].planTypeKey === planTypeKey)

  const filterResults = {}
  const benefits = [
    { name: 'deductible', key: 'deductible' },
    { name: 'coinsurance', key: 'userCoinsurance' },
    { name: 'coverage', key: 'lifetimeMax' },
    { name: 'moop', key: 'outOfPocketMax' }
  ]

  benefits.forEach(benefit => {
    const filter = filters.find(filter => benefit.name === filter.filterName)

    filterResults[benefit.key] = filter
      ? +filter.filterValue
      : +filtersByProductType[planTypeKey][benefit.name]
  })

  const newPlanId = plansByType.find(pId => {
    const p = plans[pId]

    return Object.keys(filterResults).reduce((accum, current) => {
      return accum && +p.coreBenefits[current] === +filterResults[current]
    }, true)
  })

  if (newPlanId) {
    filters.forEach(filter => {
      if (filter.filterName === 'period') {
        const { period, policies } = parsePlanPeriod(String(filter.filterValue))

        filtersByProductType[planTypeKey] = {
          ...filtersByProductType[planTypeKey],
          period,
          policies
        }
      } else {
        filtersByProductType[planTypeKey][filter.filterName] = filter.filterValue
      }
    })

    return {
      alternativePlanId: newPlanId,
      planFilter: filtersByProductType[planTypeKey],
      hasForceFilterChange: false
    }
  }

  const alternativePlan = findAlternativePlan({
    filters,
    planTypeKey,
    planIds: plansByType,
    plans,
    filtersByProductType
  })

  return alternativePlan
    ? {
        planFilter: generatePlanFilter({
          plan: alternativePlan,
          period: filtersByProductType[planTypeKey].period,
          policies: filtersByProductType[planTypeKey].policies
        }),
        hasForceFilterChange: true,
        alternativePlanId: alternativePlan.planId
      }
    : {
        alternativePlanId: undefined,
        planFilter: filtersByProductType[planTypeKey],
        hasForceFilterChange: false
      }
}

export default fitPlanConfigurationForFilter
